export default __webpack_public_path__ + "static/media/231122_Nomady_DigitalFormats_AppWelcome2.3606570c.webp";